var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{name:'Home'}}},[_vm._v("Aquí")])],1),_c('li',[_c('router-link',{attrs:{"to":{name:'Victimas'}}},[_vm._v("Víctimas")])],1),_c('li',[_c('router-link',{attrs:{"to":{name:'Condenados'}}},[_vm._v("Condenados")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }